import safeStorage from '@github-ui/safe-storage'

export const safeLocalStorage = safeStorage('localStorage')
